import { gql } from '__generated__'

export const UpdateSystemStatus = gql(/* GraphQL */ `
    mutation UpdateSystemStatus(
        $candidateIds: [ID!]!
        $systemStatus: SystemStatus!
    ) {
        updateCandidateSystemStatus(
            candidateIds: $candidateIds
            systemStatus: $systemStatus
        ) {
            message
            success
        }
    }
`)
